package one.healthium.ui.compose.components

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import androidx.compose.ui.util.fastForEachIndexed
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.black
import one.healthium.ui.compose.theme.gray_2


@Composable
fun AppSegmentedButtonRow(
    options: List<String>,
    selected: Int,
    onOptionSelected: (index: Int) -> Unit,
) {
    Row(
        horizontalArrangement = Arrangement.spacedBy(8.dp),
    ) {
        options.fastForEachIndexed { index, option ->
            AppSegmentedButton(
                position = AppSegmentedButtonPosition.fromIndex(index, options.size),
                text = option,
                selected = index == selected,
                onClick = { onOptionSelected(index) },
            )
        }
    }
}

@Composable
fun AppSegmentedButton(
    text: String,
    position: AppSegmentedButtonPosition,
    selected: Boolean,
    onClick: () -> Unit,
) {
    AppButton(
        modifier = Modifier
            .height(48.dp)
            .defaultMinSize(minWidth = 104.dp),
        onClick = onClick,
        shape = position.toShape(),
        colors = AppButtonDefaults.appButtonColors(
            containerColor = if (selected) AppTheme.colors.primary else gray_2,
            contentColor = if (selected) AppTheme.colors.onPrimary else black,
        ),
        elevation = if (selected) AppButtonDefaults.elevatedButtonElevation else null,
    ) {
        Text(text = text)
    }
}


private val CornerMax = 12.dp
private val CornerMin = 4.dp

private val ShapeStart = RoundedCornerShape(
    topStart = CornerMax,
    bottomStart = CornerMax,
    topEnd = CornerMin,
    bottomEnd = CornerMin,
)

private val ShapeMiddle = RoundedCornerShape(
    topStart = CornerMin,
    bottomStart = CornerMin,
    topEnd = CornerMin,
    bottomEnd = CornerMin,
)

private val ShapeEnd = RoundedCornerShape(
    topStart = CornerMin,
    bottomStart = CornerMin,
    topEnd = CornerMax,
    bottomEnd = CornerMax,
)

private fun AppSegmentedButtonPosition.toShape() =
    when (this) {
        AppSegmentedButtonPosition.Start -> ShapeStart
        AppSegmentedButtonPosition.End -> ShapeEnd
        AppSegmentedButtonPosition.Middle -> ShapeMiddle
    }

enum class AppSegmentedButtonPosition {
    Start,
    End,
    Middle;

    companion object {
        fun fromIndex(index: Int, size: Int) =
            when (index) {
                0 -> Start
                size - 1 -> End
                else -> Middle
            }
    }
}

@Composable
@Preview(showBackground = true)
internal fun AppSegmentedButtonRowPreview() {
    AppTheme {
        Column {
            AppSegmentedButtonRow(
                options = listOf("First", "Second"),
                selected = 0,
                onOptionSelected = {},
            )
            Spacer(Modifier.height(16.dp))
            AppSegmentedButtonRow(
                options = listOf("First", "Second", "Third"),
                selected = 0,
                onOptionSelected = {},
            )
        }
    }
}